import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

/** 1 = cash in, 2 = cash out (matches legacy CashierLogType). */
export type CashierLogTypeCode = 1 | 2;

@Injectable({
    providedIn: 'root'
})
export class CashInOutDialogService {
    private readonly openRequest = new Subject<CashierLogTypeCode>();
    private readonly savedRequest = new Subject<void>();

    /** Emits when the menu or another host requests opening the dialog. */
    readonly open$: Observable<CashierLogTypeCode> = this.openRequest.asObservable();

    /** Emits after a cash in/out log is saved successfully. */
    readonly saved$: Observable<void> = this.savedRequest.asObservable();

    open(logType: CashierLogTypeCode): void {
        this.openRequest.next(logType);
    }

    openCashIn(): void {
        this.open(1);
    }

    openCashOut(): void {
        this.open(2);
    }

    notifySaved(): void {
        this.savedRequest.next();
    }
}
